import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-location';

export const RouterLink = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => <Link _ref={ref} {...props} />);
